import { render, staticRenderFns } from "./agentDetails.vue?vue&type=template&id=498b9fa8&scoped=true&"
import script from "./agentDetails.vue?vue&type=script&lang=js&"
export * from "./agentDetails.vue?vue&type=script&lang=js&"
import style0 from "./agentDetails.vue?vue&type=style&index=0&id=498b9fa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498b9fa8",
  null
  
)

export default component.exports